import * as Sentry from '@sentry/browser';

const name = 'module-team-overview';

export default class TeamOverviewModule {

  constructor ($el) {
    this.$el = $el;
    this.ajaxLimit = 12;
    this.activeButton = null;

    this.$ajaxTarget = this.$el.querySelector(`.${name}__items`);
    this.$ajaxButtonMore = this.$el.querySelector(`.${name}__button-more`);
    this.$ajaxButtonAll = this.$el.querySelector(`.${name}__button-all`);

    this.ajaxOffset = parseInt(this.$el.dataset.ajaxOffset);
    this.ajaxUrl = this.$el.dataset.ajaxUrl;

    if (this.$ajaxButtonMore) {
      this.$ajaxButtonMore.addEventListener('click', this.onLoadMoreClick.bind(this, this.$ajaxButtonMore));
    }

    if (this.$ajaxButtonAll) {
      this.$ajaxButtonAll.addEventListener('click', this.onLoadAllClick.bind(this, this.$ajaxButtonAll));
    }

    this.initMembers();
  }

  initMembers () {
    this.members = this.$el.querySelectorAll('.team-member');

    let index = 1;
    this.members.forEach($member => {
      const $links = $member.querySelectorAll('.team-member__link');
      $member.dataset.index = index++;

      $links.forEach($link => {
        $link.addEventListener('click', this.onLinkClick.bind(this, $member, $link));
      });
    });
  }

  onLinkClick ($member, $link, event) {
    event.preventDefault();

    let stateObj = {member: $member.dataset.id};
    const url = '?off=' + $member.dataset.index
      + '&sc=' + (this.isShowcasedOverview() ? '1' : '0')
      + '#m' + $member.dataset.id;

    history.pushState(stateObj, '', url);

    window.location = $link.href;
  }

  onLoadMoreClick () {
    this.disableLoadButtons();
    this.loadItemsFromAPI();
  }

  onLoadAllClick () {
    this.disableLoadButtons();
    this.loadItemsFromAPI(true);
  }

  loadItemsFromAPI (disableLimit = false) {
    const requestData = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        showcased: this.isShowcasedOverview(),
        offset: this.ajaxOffset,
        limitDisabled: disableLimit === true
      })
    };

    const request = this.callWordpressBackend(requestData);

    request.then(response => {
      if (response.output !== null && typeof response.output === 'string') {
        this.appendLoadedItems(response.output);
        this.stopAjaxIfEndReached();
        this.initMembers();

        this.ajaxOffset += 12;
      }
    });
  }

  appendLoadedItems (newHTML) {
    let div = document.createElement('div');
    div.innerHTML = newHTML;

    while (div.children.length > 0) {
      this.$ajaxTarget.appendChild(div.children[0]);
    }
  }

  stopAjaxIfEndReached () {
    if (this.$el.querySelector(`.${name}__ajax-stopper`) !== null) {
      this.disableLoadButtons();
    } else {
      this.enableLoadButtons();
    }
  }

  async callWordpressBackend (requestData) {
    return fetch(this.ajaxUrl, requestData)
      .then(response => {
        if (!response.ok) {
          this.logIssueToSentry(response);
        }

        return response.json();
      })
      .catch(response => {
        this.logIssueToSentry(response);
      });
  }

  isShowcasedOverview () {
    return this.$el.dataset.showcase === '1';
  }

  disableLoadButtons () {
    this.$ajaxButtonMore.setAttribute('disabled', 'disabled');
    this.$ajaxButtonAll.setAttribute('disabled', 'disabled');
  }

  enableLoadButtons () {
    this.$ajaxButtonMore.removeAttribute('disabled');
    this.$ajaxButtonAll.removeAttribute('disabled');
  }

  logIssueToSentry (error) {
    Sentry.withScope(scope => {
      // Set the module name as the fingerprint
      scope.setFingerprint([name]);
      // Append the fetch error to the error data
      scope.setExtra('response', error);
      // Send the error to Sentry
      Sentry.captureException('Error while loading team members from API');
    });
  }
}
